/* global Microsoft */
/**
 * Devido à ausência de node modules e o código ser assíncrono,
 * optei por tentar trabalhar o mínimo necessário com javascript puro
 * e transferir o estado carregado para o Vuex.
 * O callback onBingMaps é caregado no index.html.
 * sdk.virtualearth.net ao invés de https://www.bing.com para evitar cookies
 * É importante garantir que:
 *  - os módulos existam quando o mapa precisar ser carregado
 *  - não penalizar a thread principal
 *  - NÃO GASTAR CRÉDITOS DESNECESSARIAMENTE DO BING
 *  - O pacote de créditos mínimo é cotado em USD 6500.00
 * @see https://learn.microsoft.com/en-us/bingmaps/v8-web-control/creating-and-hosting-map-controls/creating-a-basic-map-control
 */

import { api } from '@/services';

export default {
  initializeStore({ commit }) {
    document.addEventListener('onBingMaps', () => {
      Microsoft.Maps.loadModule('Microsoft.Maps.SpatialMath', () => {
        commit('SET_MODULE_SPACIAL_MATH', true);
      });
      Microsoft.Maps.loadModule('Microsoft.Maps.Clustering', () => {
        commit('SET_MODULE_CLUSTERING', true);
      });
      Microsoft.Maps.loadModule('Microsoft.Maps.Directions', () => {
        commit('SET_MODULE_DIRECTIONS', true);
      });
    });
    const script = document.createElement('script');
    script.src = `https://sdk.virtualearth.net/maps/sdk/mapcontrol?key=${process.env.VUE_APP_BING_API_KEY}&callback=onBingMaps`;
    script.async = 'async';
    script.defer = 'defer';
    document.head.append(script);
  },
  async setMapsAPI({ commit }, payload) {
    commit('SET_MAPS_API', payload);
  },
  async fetchViagemRemota(_, payload) {
    return api.get(`/tracking/viagens/${payload.fil_cod}/${payload.pri_cod}`);
  },
  async fetchData(_, payload) {
    return api.get(payload);
  },
};
